import {
  SketchEntitiesTransformCommand,
  canShowSketchPropertySection,
  registerPropertyManagerSection,
} from '@/core';
import SketchCopyEntitiesPropertySection from '@/components/editor/property-manager/entities-transform/SketchCopyEntitiesPropertySection.vue';

registerPropertyManagerSection({
  id: 'sketch-copy-entities',
  title: '复制实体',
  order: 19,
  component: SketchCopyEntitiesPropertySection,
  exclusive: true,
  actions: {
    confirm: true,
    cancel: true,
  },
  resolveConfirmDisabled: (context) => context.sketchEntitiesTransformState?.canConfirm === false,
  isApplicable: (context) => {
    return canShowSketchPropertySection(
      context,
      context.isSketchActive
        && context.activeCommand === SketchEntitiesTransformCommand.Copy
        && context.sketchEntitiesTransformState?.active === true,
    );
  },
  onConfirm: (context) => {
    void context.confirmSketchEntitiesTransform?.();
  },
  onCancel: (context) => {
    context.cancelSketchEntitiesTransform?.();
  },
});
